import { Checkbox, FormControlLabel } from '@mui/material';
import { useEffect, useState } from 'react';

import { SurveyQuestion } from '../../types';
import { useSxStyles } from '../useStyles';

export const CheckBoxGroupController = ({
  values,
  onChange,
  question,
}: {
  question: SurveyQuestion;
  values: number[];
  onChange: (valueList: number[]) => void;
}) => {
  const sxStyles = useSxStyles();
  const [choiceArray, setChoiceArray] = useState<number[]>([]);

  const choiceArrayChange = (id: number) => {
    const findNumber = choiceArray.find((choice) => choice === id);
    if (findNumber) {
      setChoiceArray(choiceArray.filter((choice) => choice !== id));
    } else {
      setChoiceArray([...choiceArray, id]);
    }
  };

  useEffect(() => {
    onChange(choiceArray);
  }, [choiceArray, onChange]);

  return (
    <>
      {question.options
        ? question.options.map((choice) => (
            <FormControlLabel
              key={choice.index}
              control={
                <Checkbox
                  color="primary"
                  sx={sxStyles.checkbox}
                  value={choice.id}
                  onChange={() => choiceArrayChange(choice.id)}
                />
              }
              label={choice.text as string}
            />
          ))
        : undefined}
    </>
  );
};
